export default __webpack_public_path__ + "static/media/cer8.5bb55b72.png";